import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

const supabase = createClient(supabaseUrl, supabaseAnonKey);

interface InitialAnalysis {
  priceRange: {
    min: number;
    max: number;
  };
  clarifyingQuestions: Array<{
    id: string;
    question: string;
    type: 'text' | 'select' | 'boolean';
    options?: string[];
  }>;
}

interface RefinedAnalysis {
  priceRange: {
    min: number;
    max: number;
  };
  confidence: 'low' | 'medium' | 'high';
  recommendations: string[];
}

export const analyzeWorkRequest = async (
  description: string,
  category: string
): Promise<InitialAnalysis> => {
  try {
    const { data, error } = await supabase.functions.invoke('initial-analysis', {
      body: { description, category }
    });

    if (error) throw new Error(error.message);
    return data;
  } catch (error) {
    console.error('Initial analysis error:', error);
    throw error;
  }
};

export const getRefinedAnalysis = async (
  description: string,
  category: string,
  answers: Record<string, string | boolean>
): Promise<RefinedAnalysis> => {
  try {
    const { data, error } = await supabase.functions.invoke('refined-analysis', {
      body: { description, category, answers }
    });

    if (error) throw new Error(error.message);
    return data;
  } catch (error) {
    console.error('Refined analysis error:', error);
    throw error;
  }
};